import { render } from "./priceTemplate.vue?vue&type=template&id=1679bb5c&scoped=true"
import script from "./priceTemplate.vue?vue&type=script&lang=js"
export * from "./priceTemplate.vue?vue&type=script&lang=js"

import "./priceTemplate.vue?vue&type=style&index=0&id=1679bb5c&lang=scss&scoped=true"

import exportComponent from "/usr/src/oho-config-test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1679bb5c"]])

export default __exports__